export default __webpack_public_path__ + "static/media/leg-right-front.b0ebd494.png";